function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.473 18H7.91a.527.527 0 01-.527-.527v-.563c0-.582.472-1.055 1.055-1.055v-.63c0-.835.679-1.514 1.514-1.514h5.48c.834 0 1.514.68 1.514 1.514v.63c.582 0 1.054.473 1.054 1.055v.563a.527.527 0 01-.527.527zM11.4 11.614a1.054 1.054 0 11-1.684-1.27l3.173-4.212a1.055 1.055 0 111.685 1.27L11.4 11.614zM3.82 5.901a1.055 1.055 0 01-1.685-1.27L5.309.422A1.054 1.054 0 116.993 1.69L3.82 5.9zM6.133 8.965A5.72 5.72 0 014.402 6.88l3.693-4.9a5.72 5.72 0 012.48 1.089 5.72 5.72 0 011.731 2.085l-3.692 4.9a5.72 5.72 0 01-2.481-1.089zM4.709 9.102c.245.25.504.49.789.705.285.215.587.397.895.564l-.688.913-1.684-1.27.688-.912zM3.386 10.857l1.685 1.27-3.174 4.21a1.055 1.055 0 11-1.684-1.269l3.173-4.211z"
});

function SvgMace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgMace;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mace.svg
// module id = 1279
// module chunks = 10